import Line from "../../../../../src/entities/Line/Line";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { Coord } from "../../../../../src/types/Interface";


export default class LineManager {
  lines = [new Line(), new Line(), new Line()];
  constructor() {
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.clearAll())
  }

  setAllVisible = (status: boolean) => [...this.lines].forEach(l => l.visible = status);
  clearAll = () => this.lines.forEach(l => l.clear());
  draw(points: Coord[]) {
    this.lines.forEach((line, lI) => {
      const nextIndex = lI != this.lines.length - 1 ? lI + 1 : 0
      line.draw(points[lI], points[nextIndex])
    })
  }
}


